import { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import { proxyFetch } from "./api/client.js";
import { readProxyLocale } from "./utils/proxyLocale.js";

export function useStatusLookup(routes, t) {
  const form = useForm({
    defaultValues: {
      token: "",
      customer_email: "",
    },
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [withdrawal, setWithdrawal] = useState(null);
  const indexWithQuery = useMemo(
    () => `${routes.index}${typeof window !== "undefined" ? window.location.search || "" : ""}`,
    [routes.index],
  );

  const submit = useCallback(
    async (values) => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await proxyFetch(routes.status_lookup, {
          method: "POST",
          json: {
            token: values.token,
            customer_email: values.customer_email,
            language: readProxyLocale(),
          },
        });

        setWithdrawal(data.ok ? data.withdrawal : null);
        setError(data.ok ? null : data.error || t("proxy.withdrawals.errors.status_not_found"));
      } catch (requestError) {
        setWithdrawal(null);
        setError(requestError?.message || t("proxy.withdrawals.errors.status_not_found"));
      } finally {
        setLoading(false);
      }
    },
    [routes.status_lookup, t],
  );

  return {
    form,
    error,
    loading,
    withdrawal,
    indexWithQuery,
    submit,
  };
}
